<div class="flex flex-col flex-nowrap justify-center items-center w-full gap-4">
  <div class="flex flex-row flex-nowrap justify-between items-center w-full">
    <p class="text-xl text-left">Timesheets</p>
    <div class="flex flex-row flex-nowrap justify-start items-center gap-4">
      <button mat-raised-button (click)="handleOnClickAddHours()">+ Add Hours</button>
      <button mat-raised-button color="accent" (click)="handleOnClickSyncToZoho()" [disabled]="isSyncing">
        @if (isSyncing) {
          <mat-spinner diameter="18" style="display:inline-block;vertical-align:middle;margin-right:6px;"></mat-spinner>
        }
        Sync to Zoho
      </button>
      @if (!isExpanded) {
        <button mat-raised-button (click)="isExpanded = true">Expand All</button>
      } @else {
        <button mat-raised-button (click)="isExpanded = false">Collapse All</button>
      }
    </div>
  </div>

  @if (_timesheetFeature.isLoadingTimesheetLines() || _timesheetFeature.isLoadingTimesheetHeaders()) {
    <div class="w-full flex justify-center items-center pt-[20px]">
      <mat-spinner></mat-spinner>
    </div>
  } @else {
    <app-timesheet-filters class="w-full" (dateFilterChanged)="onDateFilterChanged()"></app-timesheet-filters>

    <mat-accordion multi class="w-full">
      @if (_timesheetFeature.groupByDateTypes() === "day") {
        <!-- group by days -->

        @for (timesheet of generateTimesheetLinesListByDate(); track timesheet.date) {
          <mat-expansion-panel [expanded]="isExpanded || !!_timesheetFeature.searchText()">
            <mat-expansion-panel-header>
              <mat-panel-title> {{ timesheet.date | date:'dd/MM/yyyy' }}</mat-panel-title>
              <mat-panel-description>
                <p>Total hours: {{ timesheet.totalHours | number: "1.0-2" }}</p>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="overflow-x-auto">
              <table class="w-full text-sm">
                <thead>
                  <tr class="border-b border-black">
                    <th class="text-left font-bold pb-1 pr-4">Date</th>
                    <th class="text-left font-bold pb-1 pr-4">Project</th>
                    <th class="text-left font-bold pb-1 pr-4">Phase</th>
                    <th class="text-left font-bold pb-1 pr-4">Task</th>
                    <th class="text-left font-bold pb-1 pr-4">Comment</th>
                    <th class="text-center font-bold pb-1 pr-4 whitespace-nowrap">Synced to Zoho</th>
                    <th class="text-right font-bold pb-1">Hours</th>
                    <th class="pb-1"></th>
                  </tr>
                </thead>
                <tbody>
                  @for (timesheetLine of timesheet.timesheetLines; track timesheetLine.entryNo) {
                    <tr class="border-b border-gray-100 hover:bg-gray-50">
                      <td class="py-2 text-gray-500 whitespace-nowrap pr-4">{{ timesheetLine.activityDate | date:'dd/MM/yyyy' }}</td>
                      <td class="py-2 text-gray-500 whitespace-nowrap pr-4" [innerHTML]="generateTimesheetLineProjectName(timesheetLine) | highlight: _timesheetFeature.searchText()"></td>
                      <td class="py-2 text-gray-500 whitespace-nowrap pr-4" [innerHTML]="generateTimesheetLinePhaseName(timesheetLine) | highlight: _timesheetFeature.searchText()"></td>
                      <td class="py-2 font-semibold hover:underline cursor-pointer pr-4 whitespace-nowrap" (click)="handleOnClickEditHours(timesheetLine)" [innerHTML]="timesheetLine.taskNo + ' ' + timesheetLine.decription | highlight: _timesheetFeature.searchText()"></td>
                      <td class="py-2 text-gray-600 w-full" [innerHTML]="timesheetLine.comment | highlight: _timesheetFeature.searchText()"></td>
                      <td class="py-2 text-center pr-4">
                        @if (getZohoSyncStatus(timesheetLine) === true) {
                          <span class="text-green-600 font-bold">✓</span>
                        } @else if (getZohoSyncStatus(timesheetLine) === false) {
                          <span class="text-red-600 font-bold">✗</span>
                        } @else {
                          <span class="text-gray-400">-</span>
                        }
                      </td>
                      <td class="py-2 text-right whitespace-nowrap">{{ timesheetLine.totalTime | number: "1.0-2" }}</td>
                      <td class="py-2 pl-2 align-middle"><button mat-icon-button (click)="handleOnClickCopyHours(timesheetLine)" title="Copy" style="width:24px;height:24px;line-height:24px;display:flex;align-items:center;justify-content:center;"><mat-icon style="font-size:16px;width:16px;height:16px;">content_copy</mat-icon></button></td>
                    </tr>
                  }
                </tbody>
              </table>
            </div>
          </mat-expansion-panel>
        } @empty {
          @if (_timesheetFeature.isLoadingTimesheetLines()) {
            <div class="w-full flex justify-center items-center pt-[20px]">
              <mat-spinner></mat-spinner>
            </div>
          } @else {
            <div class="w-full flex justify-center items-center pt-[20px]">
              <p class="text-lg">No entries yet.</p>
            </div>
          }
        }
      } @else if (_timesheetFeature.groupByDateTypes() === "week") {
        <!-- group by weeks -->

        @for (timesheetWeek of generateTimesheetLinesByWeek(); track timesheetWeek.startDateOfWeek) {
          <mat-expansion-panel [expanded]="isExpanded || !!_timesheetFeature.searchText()">
            <mat-expansion-panel-header>
              <mat-panel-title> {{ timesheetWeek.startDateOfWeek | date:'dd/MM/yyyy' }} to {{ timesheetWeek.endDateOfWeek | date:'dd/MM/yyyy' }}</mat-panel-title>
              <mat-panel-description>
                <p>Total hours: {{ timesheetWeek.totalHours | number: "1.0-2" }}</p>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="overflow-x-auto">
              <table class="w-full text-sm">
                <thead>
                  <tr class="border-b border-black">
                    <th class="text-left font-bold pb-1 pr-4">Date</th>
                    <th class="text-left font-bold pb-1 pr-4">Project</th>
                    <th class="text-left font-bold pb-1 pr-4">Phase</th>
                    <th class="text-left font-bold pb-1 pr-4">Task</th>
                    <th class="text-left font-bold pb-1 pr-4">Comment</th>
                    <th class="text-center font-bold pb-1 pr-4 whitespace-nowrap">Synced to Zoho</th>
                    <th class="text-right font-bold pb-1">Hours</th>
                    <th class="pb-1"></th>
                  </tr>
                </thead>
                <tbody>
                  @for (timesheetLineByDay of timesheetWeek.timesheetLinesByDay; track timesheetLineByDay.date) {
                    <tr class="bg-gray-50 border-t border-gray-200">
                      <td colspan="5" class="py-1 font-semibold text-gray-600">{{ timesheetLineByDay.date | date:'EEEE, dd/MM/yyyy' }}</td>
                      <td></td>
                      <td class="py-1 font-semibold text-right whitespace-nowrap" [class.text-red-600]="timesheetLineByDay.totalHours < 8" [class.text-gray-600]="timesheetLineByDay.totalHours >= 8">Total: {{ timesheetLineByDay.totalHours | number: "1.0-2" }}</td>
                      <td></td>
                    </tr>
                    @for (timesheetLine of timesheetLineByDay.timesheetLines; track timesheetLine.entryNo) {
                      <tr class="border-b border-gray-100 hover:bg-gray-50">
                        <td class="py-2 px-2 text-gray-500 whitespace-nowrap pr-4">{{ timesheetLine.activityDate | date:'dd/MM/yyyy' }}</td>
                        <td class="py-2 px-2 text-gray-500 whitespace-nowrap pr-4" [innerHTML]="generateTimesheetLineProjectName(timesheetLine) | highlight: _timesheetFeature.searchText()"></td>
                        <td class="py-2 px-2 text-gray-500 whitespace-nowrap pr-4" [innerHTML]="generateTimesheetLinePhaseName(timesheetLine) | highlight: _timesheetFeature.searchText()"></td>
                        <td class="py-2 px-2 font-semibold hover:underline cursor-pointer pr-4 whitespace-nowrap" (click)="handleOnClickEditHours(timesheetLine)" [innerHTML]="timesheetLine.taskNo + ' ' + timesheetLine.decription | highlight: _timesheetFeature.searchText()"></td>
                        <td class="py-2 px-2 text-gray-600 w-full" [innerHTML]="timesheetLine.comment | highlight: _timesheetFeature.searchText()"></td>
                        <td class="py-2 px-2 text-center pr-4">
                          @if (getZohoSyncStatus(timesheetLine) === true) {
                            <span class="text-green-600 font-bold">✓</span>
                          } @else if (getZohoSyncStatus(timesheetLine) === false) {
                            <span class="text-red-600 font-bold">✗</span>
                          } @else {
                            <span class="text-gray-400">-</span>
                          }
                        </td>
                        <td class="py-2 px-2 text-right whitespace-nowrap">{{ timesheetLine.totalTime | number: "1.0-2" }}</td>
                        <td class="py-2 pl-2 align-middle"><button mat-icon-button (click)="handleOnClickCopyHours(timesheetLine)" title="Copy" style="width:24px;height:24px;line-height:24px;display:flex;align-items:center;justify-content:center;"><mat-icon style="font-size:16px;width:16px;height:16px;">content_copy</mat-icon></button></td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
            </div>
          </mat-expansion-panel>
        } @empty {
          @if (_timesheetFeature.isLoadingTimesheetLines()) {
            <div class="w-full flex justify-center items-center pt-[20px]">
              <mat-spinner></mat-spinner>
            </div>
          } @else {
            <div class="w-full flex justify-center items-center pt-[20px]">
              <p class="text-lg">No entries yet for this week.</p>
            </div>
          }
        }
      } @else {
        <!-- group by months -->

        @for (timesheetMonth of generateTimesheetLinesByMonth(); track timesheetMonth.month) {
          <mat-expansion-panel [expanded]="isExpanded || !!_timesheetFeature.searchText()">
            <mat-expansion-panel-header>
              <mat-panel-title> {{ timesheetMonth.month }} ({{ timesheetMonth.year }})</mat-panel-title>
              <mat-panel-description>
                <p>Total hours: {{ timesheetMonth.totalHours | number: "1.0-2" }}</p>
              </mat-panel-description>
            </mat-expansion-panel-header>

            <div class="overflow-x-auto">
              <table class="w-full text-sm">
                <thead>
                  <tr class="border-b border-black">
                    <th class="text-left font-bold pb-1 pr-4">Date</th>
                    <th class="text-left font-bold pb-1 pr-4">Project</th>
                    <th class="text-left font-bold pb-1 pr-4">Phase</th>
                    <th class="text-left font-bold pb-1 pr-4">Task</th>
                    <th class="text-left font-bold pb-1 pr-4">Comment</th>
                    <th class="text-center font-bold pb-1 pr-4 whitespace-nowrap">Synced to Zoho</th>
                    <th class="text-right font-bold pb-1">Hours</th>
                    <th class="pb-1"></th>
                  </tr>
                </thead>
                <tbody>
                  @for (timesheetLineByDay of timesheetMonth.timesheetLinesByDay; track timesheetLineByDay.date) {
                    <tr class="bg-gray-50 border-t border-gray-200">
                      <td colspan="5" class="py-1 font-semibold text-gray-600">{{ timesheetLineByDay.date | date:'EEEE, dd/MM/yyyy' }}</td>
                      <td></td>
                      <td class="py-1 font-semibold text-right whitespace-nowrap" [class.text-red-600]="timesheetLineByDay.totalHours < 8" [class.text-gray-600]="timesheetLineByDay.totalHours >= 8">Total: {{ timesheetLineByDay.totalHours | number: "1.0-2" }}</td>
                      <td></td>
                    </tr>
                    @for (timesheetLine of timesheetLineByDay.timesheetLines; track timesheetLine.entryNo) {
                      <tr class="border-b border-gray-100 hover:bg-gray-50">
                        <td class="py-2 px-2 text-gray-500 whitespace-nowrap pr-4">{{ timesheetLine.activityDate | date:'dd/MM/yyyy' }}</td>
                        <td class="py-2 px-2 text-gray-500 whitespace-nowrap pr-4" [innerHTML]="generateTimesheetLineProjectName(timesheetLine) | highlight: _timesheetFeature.searchText()"></td>
                        <td class="py-2 px-2 text-gray-500 whitespace-nowrap pr-4" [innerHTML]="generateTimesheetLinePhaseName(timesheetLine) | highlight: _timesheetFeature.searchText()"></td>
                        <td class="py-2 px-2 font-semibold hover:underline cursor-pointer pr-4 whitespace-nowrap" (click)="handleOnClickEditHours(timesheetLine)" [innerHTML]="timesheetLine.taskNo + ' ' + timesheetLine.decription | highlight: _timesheetFeature.searchText()"></td>
                        <td class="py-2 px-2 text-gray-600 w-full" [innerHTML]="timesheetLine.comment | highlight: _timesheetFeature.searchText()"></td>
                        <td class="py-2 px-2 text-center pr-4">
                          @if (getZohoSyncStatus(timesheetLine) === true) {
                            <span class="text-green-600 font-bold">✓</span>
                          } @else if (getZohoSyncStatus(timesheetLine) === false) {
                            <span class="text-red-600 font-bold">✗</span>
                          } @else {
                            <span class="text-gray-400">-</span>
                          }
                        </td>
                        <td class="py-2 px-2 text-right whitespace-nowrap">{{ timesheetLine.totalTime | number: "1.0-2" }}</td>
                        <td class="py-2 pl-2 align-middle"><button mat-icon-button (click)="handleOnClickCopyHours(timesheetLine)" title="Copy" style="width:24px;height:24px;line-height:24px;display:flex;align-items:center;justify-content:center;"><mat-icon style="font-size:16px;width:16px;height:16px;">content_copy</mat-icon></button></td>
                      </tr>
                    }
                  }
                </tbody>
              </table>
            </div>
          </mat-expansion-panel>
        } @empty {
          @if (_timesheetFeature.isLoadingTimesheetLines()) {
            <div class="w-full flex justify-center items-center pt-[20px]">
              <mat-spinner></mat-spinner>
            </div>
          } @else {
            <div class="w-full flex justify-center items-center pt-[20px]">
              <p class="text-lg">No entries yet for this month.</p>
            </div>
          }
        }
      }
    </mat-accordion>
  }
</div>
